import type { ChatChannelUserItem } from '@module/apis/client-side/chat/type';
import { DeviceAppMobile, DeviceAppPc, DeviceWebMobile, DeviceWebPc } from '@module/svg/icons';

import type { JSX } from 'react';

export const deviceIconMap: Record<NonNullable<ChatChannelUserItem['deviceType']>, JSX.Element> = {
  webPc: <DeviceWebPc />,
  win: <DeviceAppPc />,
  webMobile: <DeviceWebMobile />,
  android: <DeviceAppMobile />,
  iOS: <DeviceAppMobile />,
};
